import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './cost.module.css';
import { Table } from 'antd';
import CostCheck from './CostCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../report/ReportCheck';

function CostListApproved(props) {
  const [list, setList] = useState([]);
  useEffect(() => {
      if (props.list) {
          const arr = props.list.filter((item) => item.ddzc_sp_state === '3' || item.ddzc_sp_state === '4' || item.ddzc_sp_state === '5' || item.ddzc_sp_state === '6');
          arr.sort((a, b) => new Date(b.ddzc_sp_ctime) - new Date(a.ddzc_sp_ctime));
          setList(arr);
      }
  }, [props.list]);

  const columns = [
      {
          title: '付款客户  ',
          dataIndex: 'ddzc_kh_name',
          key: 'ddzc_kh_name',
          width: "20%",
          render: (_, record) =>  <CostCheck
                                        type='button'
                                        ddzc_id={record.ddzc_sp_ddzc_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddzc_bzd_id={record.ddzc_bzd_id}
                                        ddzc_price={record.ddzc_price}
                                        ddzc_content={record.ddzc_content}
                                        ddzc_date={record.ddzc_date}
                                        ddzc_date_end={record.ddzc_date_end}
                                        ddzc_bzd_name={record.ddzc_bzd_name}
                                        ddzc_bzd_danhao={record.ddzc_bzd_danhao}
                                        ddzc_type_id={record.ddzc_type_id}
                                        ddzc_type_name={record.ddzc_type_name}
                                        ddzc_kh_id={record.ddzc_kh_id}
                                        ddzc_kh_name={record.ddzc_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddzc_num={record.ddzc_num}
                                        ddzc_amount={record.ddzc_amount}
                                        ddzc_state={record.ddzc_state}
                                        ddzc_bm_id={record.ddzc_bm_id}
                                        ddzc_bm_name={record.ddzc_bm_name}
                                        ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                        ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                        ddzc_image_name={record.ddzc_image_name}
                                        ddzc_image_file={record.ddzc_image_file}
                                        ddzc_ctime={record.ddzc_ctime}
                                        ddzc_sp_state={record.ddzc_sp_state}
                                        ddzc_sp_ddzc_kh_name={record.ddzc_sp_ddzc_kh_name}
                                        ddzc_sp_kh_name={record.ddzc_sp_kh_name}
                                        ddzc_sp_yh_id={record.ddzc_sp_yh_id}
                                        ddzc_sp_yh_name={record.ddzc_sp_yh_name}
                                        ddzc_sp_dsbzd_name={record.ddzc_sp_dsbzd_name}
                                        ddzc_sp_dsbzd_id={record.ddzc_sp_dsbzd_id}
                                        ddzc_sp_dsbzd_danhao={record.ddzc_sp_dsbzd_danhao}
                                    />
      },
      {
          key: 'ddzc_sp_ddzc_amount',
          dataIndex: 'ddzc_sp_ddzc_amount',
          title: "付款金额",
          width: "6%",            
          render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          })}</span>
      },
    
      {
          key: 'ddzc_sp_ddzc_content',
          dataIndex: 'ddzc_sp_ddzc_content',
          title: "备注",
          width: "8%",
          render: (text, record) => <Copy title={text}/>
      },
      {
          key: 'ddzc_sp_dsbzd_name',
          dataIndex: 'ddzc_sp_dsbzd_name',
          title: "团队名称",
          width: "8%",
          render: (text, record) => <ReportCheck dsbzd_name={record.ddzc_sp_dsbzd_name} dsbzd_id={record.ddzc_sp_dsbzd_id} dsbzd_danhao={record.ddzc_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
      },
      {
          key: 'ddzc_sp_uname',
          dataIndex: 'ddzc_sp_uname',
          title: "提交记录",
          width: "8%",
          render: (text, record) => <>{record.ddzc_sp_uname} {record.ddzc_sp_ctime}</>,
      },
      {
          title: '状态',
          dataIndex: 'ddzc_sp_state',
          width: '5%',
          key: 'ddzc_sp_state',            
          render:(text) => <StateTag state={text} />
      },       
      {
          title: '编号',
          dataIndex: 'ddzc_sp_ddzc_id',
          width: '5%',
          key: 'ddzc_sp_ddzc_id',                        
      },    
  ]
  return (
      <>
          <Table 
              className={classes.greenHeader}
              size='small'
              bordered
              dataSource={list} 
              columns={columns} 
              rowKey='ddzc_sp_id'
              locale={{
                  emptyText: '暂无付款单' // This will display text when the table is empty
              }}
          />

      </>
  )
}

export default CostListApproved